import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { useEffect, useState } from "react";
import { getImagenesInicio } from "../../../../config/services/strapi/home";

import "swiper/css";
import "swiper/css/pagination";
import "./heroSlider.css";

interface Slide {
  id?: number;
  image?: string;
  title: string;
  position?: string;
}

export default function HeroSlider() {
  const [slides, setSlides] = useState<Slide[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const data = await getImagenesInicio();

        if (data && Array.isArray(data)) {
          const formattedSlides = data.map((item: any) => ({
            id: item.id,
            image: item.portada?.url || item.imagen?.url,
            title: item.titulo || "",
            position: "center"
          }));

          setSlides(formattedSlides);
        }
      } catch (error) {
        console.error("Error cargando imágenes:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSlides();
  }, []);

  if (loading) {
    return (
      <div className="hero-slider hero-slider-skeleton" aria-label="Cargando portada">
        <div className="hero-slider-skeleton-overlay" />
        <div className="hero-slider-skeleton-title">
          <span />
          <span />
        </div>
      </div>
    );
  }

  const defaultSlides: Slide[] = slides.length > 0 ? slides : [
    {
      title: "Cargando...",
      position: "center"
    }
  ];

  return (
    <Swiper
      modules={[Autoplay, Pagination]}
      loop
      autoplay={{
        delay: 3000,
        disableOnInteraction: false
      }}
      pagination={{ clickable: true }}
      speed={400}
      slidesPerView={1}
      className="hero-slider"
    >
      {defaultSlides.map((slide, index) => (
        <SwiperSlide key={slide.id || index}>
          <div
            className="slide"
            style={{
              backgroundImage: slide.image ? `url(${slide.image})` : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              backgroundPosition: slide.position || "center"
            }}
          >
            <div className="overlay" />
            <h1 className="slide-title">{slide.title}</h1>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}